import { render } from "./PostFeed.html?vue&type=template&id=e2cbfbaa"
import script from "./PostFeed.js?vue&type=script&lang=js"
export * from "./PostFeed.js?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__